var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuttrema-layout-content',[_c('nuttrema-empty-result',{attrs:{"slot":"central","icon":"far fa-volume-mute"},slot:"central"},[_c('template',{slot:"text"},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('h4',[_vm._v("Page not found...")])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64834bf0","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/professional/errors/page-404.vue
// module id = 3141
// module chunks = 0